export default __webpack_public_path__ + "static/media/reveal.4868cd87.wav";